import router from '@/router/index';
/**
 * 根据传入URL,提取query的参数
 */

export function getQueryParams(url: string) {
  const queryString = url.split('?')[1] || ''; // 获取查询字符串，如果没有则返回空字符串
  const paramsArray = queryString.split('&'); // 分割成键值对数组
  const queryParams = {} as Record<string, string>;
  paramsArray.forEach((item) => {
    if (item) {
      // 确保不为空字符串
      const [key, value] = item.split('='); // 分割键和值
      if (key) {
        queryParams[key] = value ? decodeURIComponent(value) : ''; // 解码并赋值
      }
    }
  });
  return queryParams;
}

export function flattenTree<T extends TreeNode>(
  tree: T[],
  childrenField: string = 'children',
): T[] {
  if (!tree || !tree.length) {
    return [];
  }

  const result: T[] = [];
  const stack: { node: T; parentId?: number | string | null }[] = [];

  tree.forEach(node => stack.push({ node, parentId: null }));

  while (stack.length > 0) {
    const { node, parentId = 0 } = stack.pop()!;
    const { [childrenField]: children, id = '', ...rest } = node;

    const flatNode: T = { id, parentId, ...rest } as T;
    result.push(flatNode);

    if (children && children.length > 0) {
      for (let i = children.length - 1; i >= 0; i--) {
        stack.push({ node: children[i], parentId: node.id || 0 });
      }
    }
  }

  return result;
}

export function arrayToTree<T extends Record<string, any>>(
  data: T[],
  options: {
    idKey?: string;
    parentIdKey?: string;
    childrenKey?: string;
    rootId?: string | number | null;
  } = {},
): T[] {
  const {
    idKey = 'id',
    parentIdKey = 'parentId',
    childrenKey = 'children',
    rootId = null,
  } = options;

  if (!data || !Array.isArray(data)) { return []; }

  const nodeMap = new Map<string | number, T>();
  const tree: T[] = [];

  // 构建哈希索引
  data.forEach((item) => {
    const node = {
      ...item,
      [childrenKey]: [] as T[],
    };
    nodeMap.set(item[idKey], node);
  });

  // 构建父子关系
  data.forEach((item) => {
    const parentId = item[parentIdKey];
    const currentNode = nodeMap.get(item[idKey]);

    if (parentId === rootId || !nodeMap.has(parentId)) {
      tree.push(currentNode!);
    }
    else {
      const parentNode = nodeMap.get(parentId);
      if (parentNode) {
        if (!parentNode[childrenKey]) {
          (parentNode as any)[childrenKey] = [];
        }
        parentNode[childrenKey]!.push(currentNode!);
      }
    }
  });

  return tree;
}
export function link(url: string) {
  router.push(url);
}

export async function copyText(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  }
  catch (err) {
    console.error('Failed to copy text: ', err);
    return false;
  }
}

/**
 * 格式化input输入的值
 */
export function formatInputValue(
  value: string | number,
  options?: {
    digit?: boolean;
    maxLength?: number;
    minLength?: number;
    max?: number;
    min?: number;
    split?: number;
  },
) {
  let filtered = String(value)
    .replace(/[^\d.]/g, '') // 只保留数字和点
    .replace(/(\..*)\./g, '$1'); // 禁止多个小数点
  if (options?.digit) {
    filtered = filtered ? String(Math.round(Number(filtered))) : filtered;
  }
  if (options?.maxLength) {
    filtered = filtered.slice(0, options.maxLength);
  }
  if (options?.minLength) {
    filtered = filtered.slice(0, options.minLength);
  }
  if (options?.max) {
    filtered = Number(filtered) > options.max ? String(options.max) : filtered;
  }
  if (options?.min) {
    filtered = Number(filtered) < options.min ? String(options.min) : filtered;
  }
  const parts = filtered.split('.');
  if (parts.length > 1 && options?.split) {
    parts[1] = parts[1].slice(0, options?.split); // 保留两位小数
    filtered = parts.join('.');
  }
  return filtered;
}
